module.exports = {"370321001":"索镇街道","370321002":"少海街道","370321101":"起凤镇","370321103":"田庄镇","370321104":"荆家镇","370321105":"马桥镇","370321107":"新城镇","370321109":"唐山镇","370321110":"果里镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370321.json
// module id = 1498
// module chunks = 0